import { useState, useEffect } from 'react';
import { RecipeResponse } from '@/types';
import { recipeService } from '@/services/recipeService';
import { useAuth } from '@/contexts/AuthContext';
import { getImageUrl } from '@/services/recipeService'; // Importar la nueva función


// export const useRecipeDetail = (recipeId?: string) => {
//     const [recipe, setRecipe] = useState<RecipeResponse | null>(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState<string | null>(null);
//     const { token, isLoggedIn } = useAuth();

//     const fetchRecipe = async () => {
//         if (!recipeId) {
//             setError('ID de receta no proporcionado');
//             setLoading(false);
//             return;
//         }

//         try {
//             setLoading(true);
//             setError(null);

//             console.log('🔍 Fetching recipe detail...', {
//                 recipeId,
//                 isLoggedIn,
//                 hasToken: !!token
//             });

//             let recipeData: RecipeResponse;

//             if (isLoggedIn && token) {
//                 // Usuario loggeado: puede acceder a recetas privadas propias
//                 recipeData = await recipeService.getRecipeById(parseInt(recipeId), token);
//             } else {
//                 // Usuario NO loggeado: solo puede acceder a recetas públicas
//                 // Primero obtenemos todas las públicas y filtramos
//                 const publicRecipes = await recipeService.getPublicRecipes();
//                 recipeData = publicRecipes.find(r => r.id === parseInt(recipeId))!;

//                 if (!recipeData) {
//                     throw new Error('Receta no encontrada o no es pública');
//                 }
//             }

//             if (recipeData.image) {
//                 recipeData.image = getImageUrl(recipeData.image);
//             }


//             console.log('✅ Recipe detail loaded:', recipeData);
//             setRecipe(recipeData);
//         } catch (err: any) {
//             console.error('❌ Error fetching recipe detail:', err);
//             setError(err.message || 'Error al cargar la receta');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchRecipe();
//     }, [recipeId, isLoggedIn, token]);

//     return {
//         recipe,
//         loading,
//         error,
//         refetch: fetchRecipe
//     };
// };
export const useRecipeDetail = (recipeId?: string) => {
    const [recipe, setRecipe] = useState<RecipeResponse | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const { token, isLoggedIn } = useAuth();

    const fetchRecipe = async () => {
        if (!recipeId) {
            setError('ID de receta no proporcionado');
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            setError(null);

            console.log('🔍 Fetching recipe detail...', {
                recipeId,
                isLoggedIn,
                hasToken: !!token
            });

            let recipeData: RecipeResponse;

            if (isLoggedIn && token) {
                recipeData = await recipeService.getRecipeById(parseInt(recipeId), token);
            } else {
                const publicRecipes = await recipeService.getPublicRecipes();
                recipeData = publicRecipes.find(r => r.id === parseInt(recipeId))!;

                if (!recipeData) {
                    throw new Error('Receta no encontrada o no es pública');
                }
            }

            // ✅ DEBUG TEMPORAL - Aquí es donde lo pones
            console.log('🔍 RecipeDetail Debug - ANTES de procesar imagen:', {
                rawImageFromAPI: recipeData.image,
                recipeId: recipeId,
                recipeTitle: recipeData.title
            });

            if (recipeData.image) {
                recipeData.image = getImageUrl(recipeData.image);
            }

            // ✅ DEBUG TEMPORAL - Después de procesar
            console.log('🔍 RecipeDetail Debug - DESPUÉS de procesar imagen:', {
                processedImage: recipeData.image,
                finalImageUrl: getImageUrl(recipeData.image)
            });

            console.log('✅ Recipe detail loaded:', recipeData);
            setRecipe(recipeData);
        } catch (err: any) {
            console.error('❌ Error fetching recipe detail:', err);
            setError(err.message || 'Error al cargar la receta');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRecipe();
    }, [recipeId, isLoggedIn, token]);

    return {
        recipe,
        loading,
        error,
        refetch: fetchRecipe
    };
};